import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { useAuth } from "./AuthContext";

const FavoritesContext = createContext(null);

export function FavoritesProvider({ children }) {
  const { user } = useAuth();
  const [ids, setIds] = useState([]);

  useEffect(() => {
    if (user) {
      api.get("/favorites/ids").then((r) => setIds(r.data)).catch(() => setIds([]));
    } else {
      setIds([]);
    }
  }, [user]);

  const toggle = useCallback(
    async (productId) => {
      if (!user) {
        toast.error("Autentifică-te pentru a salva produse la favorite");
        return;
      }
      try {
        const { data } = await api.post(`/favorites/${productId}/toggle`);
        setIds((prev) =>
          data.favorite ? [...prev, productId] : prev.filter((i) => i !== productId)
        );
        toast.success(data.favorite ? "Adăugat la favorite" : "Eliminat de la favorite");
      } catch {
        toast.error("Nu am putut actualiza favoritele");
      }
    },
    [user]
  );

  const isFav = useCallback((id) => ids.includes(id), [ids]);

  return (
    <FavoritesContext.Provider value={{ ids, toggle, isFav }}>
      {children}
    </FavoritesContext.Provider>
  );
}

export const useFavorites = () => useContext(FavoritesContext);
